// Heda platform bridge. Platform mode is opt-in at build time
// (REACT_APP_PLATFORM=1, see .env.platform.example): people sign in on the
// platform, which opens this app with a one-time #platform_token=...
// Standalone builds never take the platform-only paths below.
import axios from 'axios';

export const PLATFORM = process.env.REACT_APP_PLATFORM === '1';
// Sub-path the app is served under (PUBLIC_URL=/quotes), '' at the root.
export const BASE = process.env.PUBLIC_URL || '';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let exchangeError = '';

/** Why the platform sign-in failed ('' when it did not). */
export const platformExchangeError = () => exchangeError;

/** Current path inside the app (without BASE), plus the query string. */
export const appPath = () => {
  const p = window.location.pathname;
  return (BASE && p.startsWith(BASE) ? p.slice(BASE.length) || '/' : p) + window.location.search;
};

/** Swap a #platform_token for this app's own login, stored the way the
 *  login screen stores it. Runs before the first render. Never throws. */
export async function platformExchange() {
  const m = window.location.hash.match(/platform_token=([^&]+)/);
  if (!m) return;
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
  // The token names who should be signed in: drop any earlier session.
  localStorage.removeItem('heda_token');
  localStorage.removeItem('user');
  try {
    const res = await axios.post(`${API}/auth/platform-exchange`, { token: decodeURIComponent(m[1]) });
    localStorage.setItem('heda_token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
  } catch (err) {
    exchangeError = err.response?.data?.detail || 'Sign-in failed. Please open the app again from Heda.';
  }
}

/** The platform's sign-in page; it brings the person back to `path`. */
export const platformSignIn = (path) =>
  window.location.assign(`/login?next=${encodeURIComponent(BASE + (path || '/'))}`);

/** The platform's app launcher. */
export const allApps = () => window.location.assign('/');

/** Toast options for a 402/403 from an AI call: under the platform, a
 *  "Top up" link to the workspace's credits. */
export const creditsToastOptions = () =>
  PLATFORM ? { action: { label: 'Top up', onClick: () => window.location.assign('/workspace/credits') } } : undefined;

/** The platform's help button (it reads localStorage.heda_platform_token itself). */
export function loadHelpWidget() {
  if (!PLATFORM || document.querySelector('script[data-heda-help]')) return;
  const s = document.createElement('script');
  s.src = '/help-widget.js';
  s.defer = true;
  s.dataset.hedaHelp = '1';
  document.head.appendChild(s);
}
